import { Injectable } from '@angular/core';
import {
  IBiometricsInstructions,
  IRoutingBiometrics,
  EBiometricsType,
  HelperTexts,
  IBiometricsUpload,
  IResultsFromBiometrics
} from 'src/app/shared/interfaces/biometrics.interface';
import { routesData } from 'src/app/shared/resources/routes.constant';

@Injectable({
  providedIn: 'root'
})
export class BiometricsDataService {
  biometricsInstructions: IBiometricsInstructions = {
    rostro: {
      title: 'Validemos tu identidad',
      subtitle: 'Escanearemos tu rostro por tu seguridad.',
      boxTitle: 'Ten en cuenta',
      instructions: [
        'Retira de tu rostro, gafas, audífonos, gorra u objetos que impidan reconocerla.',
        'Asegúrate de tener una buena iluminación.',
        'Alista tu cédula, la necesitarás en los siguientes pasos.'
      ]
    },
    'documento-frontal': {
      title: 'Escanea tu cédula',
      subtitle: 'Alista tu documento.',
      boxTitle: 'Ten en cuenta',
      instructions: [
        'Deja el documento en superficie plana y asegúrate de tener una buena iluminación.',
        'Usa la guía y no muevas la cámara mientras escanéas tu documento.',
        'Evita los reflejos y la sombras, los datos deben verse legibles.'
      ]
    },
    'documento-posterior': {
      title: 'Escanea tu cédula',
      subtitle: 'Alista tu documento.',
      boxTitle: 'Ten en cuenta',
      instructions: [
        'Deja el documento en superficie plana y asegúrate de tener una buena iluminación.',
        'Usa la guía y no muevas la cámara mientras escanéas tu documento.',
        'Evita los reflejos y la sombras, los datos deben verse legibles.'
      ]
    }
  };

  generalData = {
    rostro: {
      filename: '_Selfie.txt',
      codeSDK: 4,
      isFrontal: false,
      picClass: 'face-measures',
      urlGif: '/common/biometrics-scanner/face.gif'
    },
    'documento-frontal': {
      filename: '_C1.txt',
      codeSDK: 3,
      isFrontal: true,
      picClass: 'document-measures',
      urlGif: '/common/biometrics-scanner/document.gif'
    },
    'documento-posterior': {
      filename: '_C2.txt',
      codeSDK: 3,
      isFrontal: false,
      picClass: 'document-measures',
      urlGif: '/common/biometrics-scanner/document.gif'
    }
  };

  routingBiometricsWeb: IRoutingBiometrics = {
    rostro: {
      upload: {
        to: ''
      },
      instructions: {
        to: `${routesData.BIOMETRY.LAUNCHER.redirectPath}/${EBiometricsType.FACE}`
      },
      launcher: {
        previous: `${routesData.BIOMETRY.INFO.redirectPath}/${EBiometricsType.FACE}`,
        to: `${routesData.BIOMETRY.RESULT.redirectPath}/${EBiometricsType.FACE}`
      },
      results: {
        to: `${routesData.BIOMETRY.UPLOAD.redirectPath}/${EBiometricsType.DOCUMENT_FRONTAL}`,
        retake: `${routesData.BIOMETRY.LAUNCHER.redirectPath}/${EBiometricsType.FACE}`
      }
    },
    'documento-frontal': {
      upload: {
        to: `${routesData.BIOMETRY.RESULT.redirectPath}/${EBiometricsType.DOCUMENT_FRONTAL}`
      },
      results: {
        to: `${routesData.BIOMETRY.UPLOAD.redirectPath}/${EBiometricsType.DOCUMENT_REAR}`,
        previous: `${routesData.BIOMETRY.UPLOAD.redirectPath}/${EBiometricsType.DOCUMENT_FRONTAL}`,
        retake: `${routesData.BIOMETRY.UPLOAD.redirectPath}/${EBiometricsType.DOCUMENT_FRONTAL}`
      },
      instructions: {
        to: ''
      },
      launcher: {
        to: ''
      }
    },
    'documento-posterior': {
      upload: {
        to: `${routesData.BIOMETRY.RESULT.redirectPath}/${EBiometricsType.DOCUMENT_REAR}`
      },
      results: {
        to: `${routesData.BIOMETRY.VALIDATION.redirectPath}`,
        retake: `${routesData.BIOMETRY.UPLOAD.redirectPath}/${EBiometricsType.DOCUMENT_REAR}`,
        previous: `${routesData.BIOMETRY.UPLOAD.redirectPath}/${EBiometricsType.DOCUMENT_REAR}`
      },
      launcher: {
        to: ''
      },
      instructions: {
        to: ''
      }
    }
  };

  routingBiometricsMobile: IRoutingBiometrics = {
    rostro: {
      upload: {
        to: ''
      },
      instructions: {
        to: `${routesData.BIOMETRY.LAUNCHER.redirectPath}/${EBiometricsType.FACE}`
      },
      launcher: {
        previous: `${routesData.BIOMETRY.INFO.redirectPath}/${EBiometricsType.FACE}`,
        to: `${routesData.BIOMETRY.RESULT.redirectPath}/${EBiometricsType.FACE}`
      },
      results: {
        to: `${routesData.BIOMETRY.INFO.redirectPath}/${EBiometricsType.DOCUMENT_FRONTAL}`,
        retake: `${routesData.BIOMETRY.LAUNCHER.redirectPath}/${EBiometricsType.FACE}`
      }
    },
    'documento-frontal': {
      upload: {
        to: ''
      },
      results: {
        to: `${routesData.BIOMETRY.LAUNCHER.redirectPath}/${EBiometricsType.DOCUMENT_REAR}`,
        retake: `${routesData.BIOMETRY.LAUNCHER.redirectPath}/${EBiometricsType.DOCUMENT_FRONTAL}`
      },
      launcher: {
        previous: `${routesData.BIOMETRY.INFO.redirectPath}/${EBiometricsType.DOCUMENT_FRONTAL}`,
        to: `${routesData.BIOMETRY.RESULT.redirectPath}/${EBiometricsType.DOCUMENT_FRONTAL}`
      },
      instructions: {
        to: `${routesData.BIOMETRY.LAUNCHER.redirectPath}/${EBiometricsType.DOCUMENT_FRONTAL}`,
        previous: `${routesData.BIOMETRY.RESULT.redirectPath}/${EBiometricsType.FACE}`
      }
    },
    'documento-posterior': {
      upload: {
        to: ''
      },
      instructions: {
        to: `${routesData.BIOMETRY.LAUNCHER.redirectPath}/${EBiometricsType.DOCUMENT_REAR}`
      },
      launcher: {
        previous: `${routesData.BIOMETRY.RESULT.redirectPath}/${EBiometricsType.DOCUMENT_FRONTAL}`,
        to: `${routesData.BIOMETRY.RESULT.redirectPath}/${EBiometricsType.DOCUMENT_REAR}`
      },
      results: {
        retake: `${routesData.BIOMETRY.LAUNCHER.redirectPath}/${EBiometricsType.DOCUMENT_REAR}`,
        to: `${routesData.BIOMETRY.VALIDATION.redirectPath}`
      }
    }
  };

  routingBiometrics: IRoutingBiometrics = this.routingBiometricsWeb;

  biometricsResults = {
    rostro: {
      title: '¿La foto se ve bien?',
      subtitle: 'Asegúrate que no se vea borrosa.',
      btnContinue: 'Sí, continuar',
      btnRedo: {
        web: 'QUIERO REPETIRLA',
        mobile: 'QUIERO REPETIRLA'
      }
    },
    'documento-frontal': {
      title: '¿La información es legible?',
      subtitle: 'Asegúrate de que los datos se vean bien.',
      btnContinue: 'Sí, continuar',
      btnRedo: {
        web: 'CARGAR NUEVAMENTE',
        mobile: 'ESCANEAR NUEVAMENTE'
      }
    },
    'documento-posterior': {
      title: '¿La información es legible?',
      subtitle: 'Asegúrate de que los datos se vean bien.',
      btnContinue: 'Sí, continuar',
      btnRedo: {
        web: 'CARGAR NUEVAMENTE',
        mobile: 'ESCANEAR NUEVAMENTE'
      }
    }
  };

  helperTexts: HelperTexts = {
    loading: {
      text: 'Cargando archivo'
    },
    initial: {
      text: 'Sube tu archivo'
    },
    failed: {
      text: 'Volver a subir tu archivo'
    },
    success: {
      text: 'Cargar otro archivo'
    }
  };

  biometricsUpload: IBiometricsUpload = {
    rostro: {
      title: '',
      subtitle: '',
      uploadComponent: {
        initial: '',
        failed: ''
      }
    },
    'documento-frontal': {
      title: 'Adjunta el frente de tu cédula',
      subtitle:
        'Aseguraté que sea legible, que este en formato jpg y sea menor a 14MB',
      uploadComponent: {
        initial: 'Subir parte frontal de la cédula',
        failed: 'Subir nuevamente'
      }
    },
    'documento-posterior': {
      title: 'Adjunta el reverso de tu cédula',
      subtitle:
        'Aseguraté que sea legible, que este en formato jpg y sea menor a 14MB',
      uploadComponent: {
        initial: 'Subir reverso de la cédula',
        failed: 'Subir nuevamente'
      }
    }
  };

  presignedUrls = {
    ExpiresTime: 0,
    rostro: '',
    'documento-frontal': '',
    'documento-posterior': ''
  };

  resultsFromBiometrics: Partial<IResultsFromBiometrics> = {};

  uploadScreenErrors = {
    format: 'Error de formato, revisa tu archivo y reintenta.',
    size: 'El archivo pesa mas de 14 MB.',
    type: 'Error de formato, inténtalo en jpg.'
  };
}
